var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.27819 16.8098C3.95269 16.5308 3.78995 16.3913 3.73032 16.2253C3.67798 16.0796 3.67798 15.9202 3.73032 15.7745C3.78995 15.6085 3.95269 15.469 4.27819 15.19L15.5725 5.5092C16.1328 5.02893 16.4129 4.7888 16.6501 4.78292C16.8563 4.77781 17.0532 4.86837 17.1834 5.02821C17.3333 5.21212 17.3333 5.5811 17.3333 6.31907V12.0461C20.1796 12.544 22.7845 13.9862 24.7204 16.1517C26.8309 18.5126 27.9984 21.5678 28 24.7345V25.5505C26.6009 23.8651 24.854 22.5019 22.879 21.5545C21.1377 20.7191 19.2554 20.2243 17.3333 20.0939V25.6807C17.3333 26.4187 17.3333 26.7877 17.1834 26.9716C17.0532 27.1314 16.8563 27.222 16.6501 27.2169C16.4129 27.211 16.1328 26.9709 15.5725 26.4906L4.27819 16.8098Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyWhite);
export default __webpack_public_path__ + "static/media/reply_white.d0a31bc91fb7b1bb69b6bfb4ec7576ac.svg";
export { ForwardRef as ReactComponent };